<!--
 * @Author: CHY
 * @Date: 2023-05-22 15:49:09
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-08-25 09:52:38
 * @FilePath: \liancan-public-screen-school\src\views\index\indexScroll.vue
-->
<template>
    <!-- 首页 -->
    <div class='vertical page_index'>
        <!-- 内容 -->
        <div class="body_part">
            <div class="left" style="width: 100vw;margin-top: -20px;">
                <slider ref="slider" :options="options">
                    <slideritem v-for="(sliItem, sliIndex) in showItem" :key="sliIndex">
                        <!-- 【采购信息公示】 -->
                        <template v-if="purchaseShow && (sliItem === (1))" >
                        <border-tab :tenderImg="ingredientsImg" :isLeft="false" width="580" height="920" left="220" custom-class="custom-title" :title="TAB_MAP_VALUE['1']">
                            <div class="page1 page-common-pad">
                                <article-list :rankList="handleArticleList(ingredientsList)" scrollHeight="785" :active="0" :dateTime="weekValue" :schoolName="deptName" ></article-list>
                            </div>
                        </border-tab>
                        </template>

                        <!-- 供餐价格公示 ==> 【餐价公示】 -->
                        <template v-if="mealShow && (sliItem === (2))">
                        <border-tab :tenderImg="mealImg" :isLeft="false" width="580" height="920" left="220" custom-class="custom-title" :title="TAB_MAP_VALUE['2']" color="#152FF2">
                            <div class="page2 page-common-pad">
                                <div class="page2-inner">
                                <schoolAndDate :schoolName="deptName" :dateTime="weekValue" />
                                <item-title-for-tab title="统缴餐" subTitle="单位：元/份"></item-title-for-tab>
                                <item-list :rankList="mealList" scrollHeight="200" :active="0" :borderWidth="266"></item-list>
                                <item-title-for-tab title="自选餐"></item-title-for-tab>
                                <item-list :rankList="optionalMealList" scrollHeight="420" :active="0" :borderWidth="170" scrollItemHeight="92%" :isStep="optionalMealList.length>=11"></item-list>
                                </div>
                            </div>
                        </border-tab>
                        </template>

                        <!-- (基于上面的)供餐价格公示 ==> 改版为【餐价公示】 -->
                        <template v-if="mealShow && (sliItem === (22))">
                        <border-tab :tenderImg="mealImg" :isLeft="false" width="580" height="920" left="220" custom-class="custom-title" :title="TAB_MAP_VALUE['22']" color="#152FF2">
                            <div class="page22 page-common-pad">
                                <daily-meal-price :dept-id="deptId" :outlets-id="outletsId" :tabStyle="true" :dateTime="weekValue" :schoolName="deptName" ></daily-meal-price>
                            </div>
                        </border-tab>
                        </template>

                        <!-- 【收入支出公示】 -->
                        <template v-if="incomeShow && (sliItem === (3))">
                        <border-tab :tenderImg="revenueImg" :isLeft="false" width="580" height="920" left="220" custom-class="custom-title" :title="TAB_MAP_VALUE['3']" color="#712D08">
                        <div class="page3-wrap page-common-pad">
                            <div class="page3 ">
                                <schoolAndDate :schoolName="deptName" :dateTime="weekValue" />
                                <!-- <div class="sub-title">{{ time }}</div> -->
                            
                            <div class="revenueExpense">
                                <div>{{monySum.isUse==1?'结账':'公示'}}月份：</div>
                                <div>{{ year }}年{{time}}</div>
                            </div>
                            <!-- 上期盈余 -->
                            <div class="currentSurplus surplus-box" v-if="monySum.isUse==1" style="padding-bottom: 0;">
                                <div>上期盈余</div>
                                <div>
                                    <span>{{formatNumber(monySum.prePeriodEarnings)}}</span>
                                    <span class="unit"> 元</span>
                                </div>
                            </div>
                            <!-- 本期收入 -->
                            <div class="surplus-box">
                                <div :class="index==0?'currentSurplus':'currentSurplusActive'" v-for="(item,index) in currentSurplusArr" :key="index">
                                    <div class="box-title">{{item.title}}</div>
                                    <div>
                                        <span>{{formatNumber(item.num)}}</span>
                                        <span class="unit"> 元</span>
                                    </div>
                                </div>
                            </div>
                            <!--本期费用  -->
                            <div class="surplus-box">
                                <div :class="index==0?'currentExpenses':'currentSurplusActive'" v-for="(item,index) in currentExpensesArr" :key="index">
                                    <div class="box-title">{{item.title}}</div>
                                    <div>
                                        <span>{{formatNumber(item.num)}}</span>
                                        <span class="unit"> 元</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 累计盈余 -->
                            <div class="accumulatedSurplus surplus-box" v-if="monySum.isUse==1">
                                <div>累计盈余</div>
                                <div>
                                    <span>{{formatNumber(monySum.allPeriodEarnings)}}</span>
                                    <span class="unit"> 元</span>
                                </div>
                            </div>
    
                            </div>
                        </div>
                        </border-tab>
                        </template>

                        <!-- 违规整改公示 -->
                        <template v-if="violateShow && (sliItem === (4))">
                        <border-line :tenderImg="violationsImg" :isLeft="false" width="580" height="920" left="220" custom-class="custom-title" title="违规整改公示">
                            <div class="page_padding">
                                <item-title title="本月违规预警" :subTitle="time" :imgLeftList="imgLeftList" :imgRightList="imgRightList"></item-title>
                                <div class="page_right">
                                    <div>
                                        <big-num :num="illegalTotal.monthViolationCount >=0 ? illegalTotal.monthViolationCount : '--'" unit="条" title="违规" color="#FFFFFF"></big-num>
                                    </div>
                                    <div>
                                        <big-num :num="illegalTotal.monthRectificationCount >= 0 ? illegalTotal.monthRectificationCount : '--'" unit="条" title="整改" color="#FFFFFF" subColor="#86FFAE"></big-num>
                                    </div>
                                </div>
                                <item-title title="累计违规预警" :imgLeftList="imgLeftList" :imgRightList="imgRightList"></item-title>
                                <div class="page_right">
                                    <div>
                                        <big-num :num="illegalTotal.cumulativeViolationCount >= 0 ? illegalTotal.cumulativeViolationCount : '--'" unit="条" title="违规" color="#FFFFFF"></big-num>
                                    </div>
                                    <div>
                                        <big-num :num="illegalTotal.cumulativeRectificationCount >= 0 ? illegalTotal.cumulativeRectificationCount : '--'" unit="条" title="整改" color="#FFFFFF" subColor="#86FFAE"></big-num>
                                    </div>
                                </div>
                            </div>
                        </border-line>
                        </template>

                        <!-- 统缴餐 -->
                        <template v-if="unifiedMealShow && (sliItem === (5))">
                        <border-line :tenderImg="unifiedMealImg" :isLeft="false" width="580" height="920" left="220" custom-class="custom-title" title="一周菜谱及收费标准" color="#152FF2">
                            <div class="page_padding">
                                <unified-meal :dept-id="deptId" :outlets-id="outletsId" />
                            </div>
                        </border-line>
                        </template>

                        <!-- 自选餐 -->
                        <template v-if="selfServiceMealShow && (sliItem === (6))">
                        <border-line :tenderImg="selfServiceMealImg" :isLeft="false" width="580" height="920" left="220" custom-class="custom-title" title="一周菜谱及收费标准" color="#152FF2">
                            <div class="page_padding">
                                <div class="self-service-meal">
                                    <self-service-meal :dept-id="deptId" :outlets-id="outletsId"/>
                                </div>
                            </div>
                        </border-line>
                        </template>

                        <!-- 【评价公示】 -->
                        <template v-if="evaluateShow && (sliItem === (7))">
                        <border-tab :tenderImg="ingredientsImg" :isLeft="false" width="580" height="920" left="220" :title="TAB_MAP_VALUE['7']">
                            <div class="page7 page-common-pad">
                                <charts-page :dept-id="deptId" :dateTime="weekValue" :schoolName="deptName"></charts-page>
                            </div>
                        </border-tab>
                        </template>

                        <!-- 当前天餐价公示 (独立版面) -->
                        <template v-if="dailyMealShow && (sliItem === (8))">
                        <border-line :tenderImg="dailyMealMealImg" :isLeft="false" width="580" height="920" left="220" custom-class="custom-title" title="餐价公示" color="#FFFFFF">
                            <div class="page_padding">
                                <daily-meal-price :dept-id="deptId" :outlets-id="outletsId"></daily-meal-price>
                            </div>
                        </border-line>
                        </template>

                        <!-- 【检测公示】 -->
                        <template v-if="determineShow && (sliItem === (9))">
                        <border-tab :tenderImg="ingredientsImg" :isLeft="false" width="580" height="920" left="220" :title="TAB_MAP_VALUE['9']">
                            <div class="page7 page-common-pad">
                                <testing-publicity :dept-id="deptId" :dateTime="weekValue" :schoolName="deptName"></testing-publicity>
                            </div>
                        </border-tab>
                        </template>

                        <!-- (当天)餐价公示(统缴餐&自选餐) ==> 【餐价公示】 -->
                        <template v-if="unifiedMealShow && (sliItem === (10))">
                        <border-tab width="580" height="920" left="220" :title="TAB_MAP_VALUE['10']">
                            <div class="page10 page-common-pad">
                                <weekForOne :dept-id="deptId" :outlets-id="outletsId" :tabStyle="true" :tjcData="handleWeekForOne(mealList)" :zxcData="optionalMealList"></weekForOne>
                            </div>
                        </border-tab>
                        </template>

                        <!-- 【自选菜价公开】 -->
                        <template v-if="unifiedMealShow && (sliItem === (11))">
                        <border-tab width="580" height="920" left="220" :title="TAB_MAP_VALUE['11']">
                            <div class="page11 page-common-pad">
                                <additionalMenu :dept-id="deptId" :outlets-id="outletsId" :zxcData="optionalMealList" :dateTime="weekValue" :schoolName="deptName"></additionalMenu>
                            </div>
                        </border-tab>
                        </template>

                        <!-- 【统餐价格公开】 -->
                        <template v-if="unifiedMealShow && (sliItem === (12))">
                        <border-tab width="580" height="920" left="220" :title="TAB_MAP_VALUE['12']">
                            <div class="page12 page-common-pad">
                                <oneWeekUnifiedMeals :dept-id="deptId" :outlets-id="outletsId" :tjcData="mealList" :dateTime="weekValue" :schoolName="deptName"></oneWeekUnifiedMeals>
                            </div>
                        </border-tab>
                        </template>
                        
                        <!-- 【带量菜谱公开】 -->
                        <template v-if="unifiedMealShow && (sliItem === (13))">
                        <border-tab width="580" height="920" left="220" :title="TAB_MAP_VALUE['13']">
                            <div class="page13 page-common-pad">
                                <nutritionalRecipe :dept-id="deptId" :outlets-id="outletsId" :tjcData="mealList" :dateTime="weekValue" :schoolName="deptName"></nutritionalRecipe>
                            </div>
                        </border-tab>
                        </template>

                        <!-- 【今日营养食谱价格公示】 -->
                        <template v-if="unifiedMealShow && (sliItem === (14))">
                        <border-tab width="580" height="920" left="220" :title="TAB_MAP_VALUE['14']">
                            <div class="page14 page-common-pad">
                                <nutritiousDiningOpen :dept-id="deptId" :outlets-id="outletsId" :dateTime="weekValue" :schoolName="deptName"></nutritiousDiningOpen>
                            </div>
                        </border-tab>
                        </template>

                        <!-- 【营养餐食品采购公示】 -->
                        <template v-if="unifiedMealShow && (sliItem === (15))">
                        <border-tab width="580" height="920" left="220" :title="TAB_MAP_VALUE['15']">
                            <div class="page15 page-common-pad">
                                <nutritiousDiningProcurement :dept-id="deptId" :outlets-id="outletsId" :dateTime="weekValue" :schoolName="deptName"></nutritiousDiningProcurement>
                            </div>
                        </border-tab>
                        </template>

                        <!-- 【营养带量食谱公示】 -->
                        <template v-if="unifiedMealShow && (sliItem === (16))">
                        <border-tab width="580" height="920" left="220" :title="TAB_MAP_VALUE['16']">
                            <div class="page16 page-common-pad">
                                <nutritiousDiningMenuWeek :dept-id="deptId" :outlets-id="outletsId" :dateTime="weekValue" :schoolName="deptName"></nutritiousDiningMenuWeek>
                            </div>
                        </border-tab>
                        </template>

                    </slideritem>

                </slider>
            </div>
        </div>
    </div>
</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';
    import borderLine from '@/components/border'; // 边框
    import borderTab from '@/components/borderTab'; // tab型标题
    import itemList from '@/components/itemList'; // 文字列表
    import itemTitle from '@/components/itemTitle'; // 标题
    import itemTitleForTab from '@/components/itemTitleForTab'; // 标题
    import bigNum from '@/components/bigNumVertical'; // 标题
    import articleList from '@/components/articleListVertical'; // 标题
    import unifiedMeal from '@/components/unifiedMeal'; // 统缴餐
    import selfServiceMeal from '@/components/selfServiceMeal'; // 统缴餐
    import chartsPage from '@/components/chartsPage.vue'; // 评价公示内容
    import dailyMealPrice from '@/components/dailyMealPrice'; // 餐价公示
    import testingPublicity from '@/components/testingPublicity.vue'; // 检测公示
    import weekForOne from '@/components/weekForOne.vue'; // 餐价公示(统缴餐&自选餐)
    import additionalMenu from '@/components/additionalMenu.vue';
    import oneWeekUnifiedMeals from '@/components/oneWeekUnifiedMeals.vue';
    import nutritionalRecipe from '@/components/nutritionalRecipe.vue';
    import nutritiousDiningOpen from '@/components/nutritiousDiningOpen.vue';
    import nutritiousDiningProcurement from '@/components/nutritiousDiningProcurement.vue';
    import nutritiousDiningMenuWeek from '@/components/nutritiousDiningMenuWeek.vue';
    import schoolAndDate from '@/components/schoolAndDate.vue';
    import {
        handleTime,
        getWeek,
        formatTime,
        keepTwoDecimalFull,
        filterTime
    } from "@/assets/js/common";
    import { TAB_MAP_VALUE } from '@/assets/js/constants';
    import {
        slider,
        slideritem
    } from 'vue-concise-slider';
    import { handleArticleList, handleWeekForOne } from '@/assets/js/mock';

    export default {
        components: {
            borderLine,
            borderTab,
            itemList,
            itemTitle,
            itemTitleForTab,
            bigNum,
            articleList,
            slider,
            slideritem,
            unifiedMeal,
            selfServiceMeal,
            chartsPage,
            dailyMealPrice,
            testingPublicity,
            weekForOne,
            additionalMenu,
            oneWeekUnifiedMeals,
            nutritionalRecipe,
            nutritiousDiningOpen,
            nutritiousDiningProcurement,
            nutritiousDiningMenuWeek,
            schoolAndDate,
        },
        data() {
            //这里存放数据
            return {
                TAB_MAP_VALUE,
                deptName:'', // 学校名称
                weekValue: '', // 日期时间

                showItem: [],
                autoplay: 5000,

                year: new Date().getFullYear(),
                time: '',
                deptId: '',
                outletsId:'', // 网点id
                imgLeftList: require("@/assets/images/icon_left02.png"),
                imgRightList: require("@/assets/images/icon_right02.png"),
                ingredientsImg: require("@/assets/images/border/vertical/bg_shicai.png"), // 食材价格公示边框图
                fuelImg: require("@/assets/images/border/bg_ranliao.png"), // 燃料价格公示边框图
                mealImg: require("@/assets/images/border/vertical/bg_gongcan.png"), // 供餐价格公示边框图
                revenueImg: require("@/assets/images/border/vertical/bg_yingshou.png"), //营收公示边框图
                violationsImg: require("@/assets/images/border/vertical/bg_weigui.png"), // 食堂违规预警公示边框图
                unifiedMealImg: require("@/assets/images/border/vertical/bg_unified_meal.png"), // 食堂违规预警公示边框图
                selfServiceMealImg: require("@/assets/images/border/vertical/bg_self_service_meal.png"), // 食堂违规预警公示边框图
                dailyMealMealImg: require("@/assets/images/border/vertical/bg_daily_meal.png"), // 食堂违规预警公示边框图
                // 显示窗体
                purchaseShow: false, //采购信息公示
                mealShow: false, // 供餐价格公示
                incomeShow: false, // 收入费用公示
                violateShow: false, // 违规整改公示
                unifiedMealShow: true, // 统缴餐统计数据公示
                selfServiceMealShow: true, // 自选餐统计数据公示
                evaluateShow: false, // 评价公示
                determineShow: false,// 检测公示
                dailyMealShow: false, // 当天餐价公示
                // current

                // 食材价格
                ingredientsList: [],
                // 燃料价格
                fuelList: [],
                // 统缴餐-供餐价格公示
                mealList: [],
                // 自选餐-供餐价格公示
                optionalMealList: [],
                // 总收入
                incomeList: [{
                        name: '餐费收入',
                        price: '--元'
                    },
                    {
                        name: '厨废收入',
                        price: '--元'
                    },
                    {
                        name: '利息收入',
                        price: '--元'
                    },
                    {
                        name: '其他收入',
                        price: '--元'
                    }
                ],
                // 总支出
                spendingList: [{
                        name: '采购支出(食材)',
                        price: '--元'
                    },
                    {
                        name: '采购支出(燃料)',
                        price: '--元'
                    },
                    {
                        name: '人员支出',
                        price: '--元'
                    },
                    {
                        name: '接待支出',
                        price: '--元'
                    },
                    {
                        name: '其他支出',
                        price: '--元'
                    }
                ],
                // 结余总额
                balanceList: [{
                    name: '结余总额',
                    price: '--元'
                }],
                illegalTotal: {},
                articleList: [],
                //2022//12/3 收入费用公示
                monySum: {},
                currentSurplusArr: [],
                currentExpensesArr: []
            };
        },
        //监听属性 类似于data概念
        computed: {
            options() {
                return {
                    effect: 'fade', //滚动滑动('slide'),可设置为渐变滑动('fade'),旋转滚动('coverflow')
                    currentPage: 0, //当前页码
                    thresholdDistance: 500, //滑动判定距离
                    thresholdTime: 500, //滑动判定时间
                    autoplay: this.autoplay, //自动滚动[ms]
                    loop: true, //循环滚动
                    direction: 'horizontal', //方向设置，水平滚动
                    loopedSlides: 1, //无限滚动前后遍历数
                    slidesToScroll: 1, //每次滑动项数
                    timingFunction: 'ease', // 滑动方式
                    speed: 800, // 滑动时间
                    pagination: false, //所有模式下分页是否显示
                }
            },
        },
        //监控data中的数据变化
        watch: {
            $route: {
                deep: true,
                immediate: true,
                handler(to) {
                    console.log('===> url值改变 <===', to)
                    if (Object.keys(to.query).length > 0) {
                        let did = to.query.id;
                        this.deptId = !did ? localStorage.getItem('deptId') : did;
                        this.outletsId = to.query.outletsId
                        this.showItem = !to.query.item ? [] : to.query.item.split(',').map(item => parseInt(item))
                        this.autoplay = to.query.autoplay ? parseInt(to.query.autoplay) : 5000
                        this.getSchoolName()
                    } else {
                        this.deptId = ''
                        this.schoolName = ''
                    }
                    this.getData()
                }
            }
        },
        //方法集合
        methods: {
            handleArticleList,
            handleWeekForOne,
            
            // 格式化数字，处理字符串和数字类型，返回两位小数格式
            formatNumber(num) {
                if (num === null || num === undefined || num === '') {
                    return '--'
                }
                const numValue = typeof num === 'string' ? parseFloat(num) : Number(num)
                if (isNaN(numValue)) {
                    return '--'
                }
                return keepTwoDecimalFull(numValue)
            },
            
            // 获取当天星期几
            getDateWeek() {
                setInterval(() => {
                    const times = formatTime(new Date(), 'yyyy-MM-dd')
                    const week = getWeek(times)
                    const time = handleTime()
                    this.weekValue = `${time} ${week}`
                }, 1000);
            },
            getSchoolName() {
                this.$get(this.$api.getCanteenDisplay, {
                    deptId: this.deptId
                }).then(res => {
                    const { code, success, data } = res
                    if (code == 200 && success) {
                        this.deptName = data.deptName
                    }
                })
            },

            showAll() {
                this.purchaseShow = true
                this.mealShow = true
                this.incomeShow = true
                this.violateShow = true
                this.evaluateShow = true
                this.determineShow = true
                this.dailyMealShow = true
            },
            getShowDivs() {
                this.$get(this.$api.getShowDivs, {
                    deptId: this.deptId ? this.deptId : localStorage.getItem('deptId')
                }).then(res => {
                    console.log('显示窗体-res', res);
                    if (res.code == 200 && res.success) {
                        if (res.data.includes('purchase')) {
                            this.purchaseShow = true;
                        }
                        if (res.data.includes('meal')) {
                            this.mealShow = true;
                        }
                        if (res.data.includes('income')) {
                            this.incomeShow = true;
                        }
                        if (res.data.includes('violate')) {
                            this.violateShow = true;
                        }
                        // TODO 修改正确的判断
                        this.showAll()
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                    console.log('显示窗体-err', err);
                })
            },
            initData() {
                // 食材价格
                this.ingredientsList = []
                // 燃料价格
                this.fuelList = []
                // 统缴餐
                this.mealList = []
                // 自选餐
                this.optionalMealList = []
                // 总收入
                this.incomeList = [{
                        name: '餐费收入',
                        price: '--',
                        expenditureUnit: '元'
                    },
                    {
                        name: '厨废收入',
                        price: '--',
                        expenditureUnit: '元'
                    },
                    {
                        name: '利息收入',
                        price: '--',
                        expenditureUnit: '元'
                    },
                    {
                        name: '其他收入',
                        price: '--',
                        expenditureUnit: '元'
                    }
                ]
                // 总支出
                this.spendingList = [{
                        name: '采购支出(食材)',
                        price: '--',
                        expenditureUnit: '元'
                    },
                    {
                        name: '采购支出(燃料)',
                        price: '--',
                        expenditureUnit: '元'
                    },
                    {
                        name: '人员支出',
                        price: '--',
                        expenditureUnit: '元'
                    },
                    {
                        name: '接待支出',
                        price: '--',
                        expenditureUnit: '元'
                    },
                    {
                        name: '其他支出',
                        price: '--',
                        expenditureUnit: '元'
                    }
                ]
                // 结余总额
                this.balanceList = [{
                    name: '结余总额',
                    price: '--',
                    expenditureUnit: '元'
                }]
                this.illegalTotal = {}
                this.articleList = []
            },


            /**
             * @function getPurchasePricePage 食堂餐价公示
             * @param deptId 食堂id
             * @param type 类型：0食材，1燃料
             * @param current 
             * @param size
             */
            getPurchasePricePage() {
                this.$get(this.$api.getLiancanPurchasePriceComparisonList, {
                    canteenId: this.deptId,
                    current: 1,
                    size: -1,
                }).then(res => {
                    console.log(`===>  (item=1) ${TAB_MAP_VALUE['1']} <===`, res)
                    const {
                        code,
                        success,
                        data: {
                            records
                        }
                    } = res
                    if (code == 200 && success) {
                        this.ingredientsList = records || []
                    }
                })
                
                // this.$get(this.$api.getPurchasePricePage, {
                //     deptId: this.deptId,
                //     current: 1,
                //     size: 10000
                // }).then(res => {
                //     console.log('采购公示-res', res)
                //     const {
                //         code,
                //         success,
                //         data: {
                //             records
                //         }
                //     } = res
                //     if (code == 200 && success) {
                //         this.ingredientsList = records
                //     }
                // }).catch(err => {
                //     this.$message.error(err.message);
                //     console.log('食堂餐价公示-err', err)
                // })
            },
            /**
             * @function getOpenMealPriceList 供餐价格公示列表（统缴餐）
             * @param deptId 食堂id
             */
            getOpenMealPriceList() {
                this.$get(this.$api.getOpenMealPriceList, {
                    deptId: this.deptId
                }).then(res => {
                    console.log('供餐价格公示列表（统缴餐）-res', res)
                    const {
                        code,
                        success,
                        message,
                        data
                    } = res
                    if (code == 200 && success) {

                        if (data.length > 0) {
                            data.forEach(item => {
                                item.name = item.type === '0' ? '早餐' : item.type === '1' ? '中餐' : item.type === '2' ? '晚餐' : '夜餐'
                            });
                            this.mealList = data
                        }
                    } else {
                        this.$message({
                            message: message || '食堂id不能为空',
                            type: 'error',
                            duration: 3000
                        });
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                    console.log('供餐价格公示列表（统缴餐）-err', err)
                })
            },
            /**
             * @function getFoodInformationPage 获取餐价公开列表（自选餐）
             * @param deptId 食堂id
             * @param current 
             * @param size
             */
            getFoodInformationPage() {
                this.$get(this.$api.getFoodInformationPage, {
                    deptId: this.deptId,
                    current: 1,
                    size: 10000
                }).then(res => {
                    console.log('获取餐价公开列表（自选餐）-res', res)
                    const {
                        code,
                        success,
                        data: {
                            records
                        }
                    } = res
                    if (code == 200 && success) {
                        this.optionalMealList = records
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                    console.log('获取餐价公开列表（自选餐）-err', err)
                })
            },
            /**
             * @function getIncomeExpenditureTotal 食堂收支结余公示
             * @param deptId 食堂id
             * @param dateType 数据类型范围（1:只查年，2:只查月，3:只查日，默认为2）
             */
            getIncomeExpenditureTotal() {
                this.$get(this.$api.getIncomeExpenditureTotal, {
                    deptId: this.deptId,
                    dateType: 2
                }).then(res => {
                    console.log('食堂收支结余公示-res', res)
                    const {
                        code,
                        success,
                        data
                    } = res
                    if (code == 200 && success) {
                        if (Object.keys(data).length > 0) {
                            // 总收入
                            this.incomeList = [{
                                    name: '餐费收入',
                                    price: `${keepTwoDecimalFull(data.mealIncome)}`,
                                    expenditureUnit: '元'
                                },
                                {
                                    name: '厨废收入',
                                    price: `${keepTwoDecimalFull(data.kitchenIncome)}`,
                                    expenditureUnit: '元'
                                },
                                {
                                    name: '利息收入',
                                    price: `${keepTwoDecimalFull(data.interestIncome)}`,
                                    expenditureUnit: '元'
                                },
                                {
                                    name: '其他收入',
                                    price: `${keepTwoDecimalFull(data.otherIncome)}`,
                                    expenditureUnit: '元'
                                }
                            ]
                            // 总支出
                            this.spendingList = [{
                                    name: '采购支出(食材)',
                                    price: `${keepTwoDecimalFull(data.foodPurchaseExpenditure)}`,
                                    expenditureUnit: '元'
                                },
                                {
                                    name: '采购支出(燃料)',
                                    price: `${keepTwoDecimalFull(data.fuelPurchaseExpenditure)}`,
                                    expenditureUnit: '元'
                                },
                                {
                                    name: '人员支出',
                                    price: `${keepTwoDecimalFull(data.wagesExpenditure)}`,
                                    expenditureUnit: '元'
                                },
                                {
                                    name: '接待支出',
                                    price: `${keepTwoDecimalFull(data.entertainExpenditure)}`,
                                    expenditureUnit: '元'
                                },
                                {
                                    name: '其他支出',
                                    price: `${keepTwoDecimalFull(data.otherExpenditure)}`,
                                    expenditureUnit: '元'
                                }
                            ]
                            // 结余总额
                            this.balanceList = [{
                                name: '结余总额',
                                price: `${data.totalBalance}`,
                                expenditureUnit: '元'
                            }]
                        }
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                    console.log('食堂收支结余公示-err', err)
                })
            },
            /**
             * @function getIllegalTotal 食堂违规预警公示总数
             * @param deptId 食堂id
             */
            getIllegalTotal() {
                this.$get(this.$api.getIllegalTotal, {
                    deptId: this.deptId
                }).then(res => {
                    console.log('食堂违规预警公示总数-res', res)
                    const {
                        code,
                        success,
                        data
                    } = res
                    if (code == 200 && success) {
                        this.illegalTotal = data
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                    console.log('食堂违规预警公示总数-err', err)
                })
            },
            /**
             * @function getIllegalPage 食堂违规预警公示（列表）
             * @param deptId 食堂id
             * @param dateType 数据类型范围（1:只查年，2:只查月，3:只查日，默认为2）
             * @param current 
             * @param size
             */
            getIllegalPage() {

                this.$get(this.$api.getIllegalPage, {
                    deptId: this.deptId,
                    dateType: 2,
                    current: 1,
                    size: 10000
                }).then(res => {
                    console.log('食堂违规预警公示（列表）-res', res)
                    const {
                        code,
                        success,
                        data: {
                            records
                        }
                    } = res
                    if (code == 200 && success) {
                        records.forEach(item => {
                            item.date = filterTime(item.date)
                        })
                        this.articleList = records
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                    console.log('食堂违规预警公示（列表）-err', err)
                })
            },
            getData() {
                let myDate = new Date();
                let tMonth = myDate.getMonth() + 1;
                this.time = `${tMonth}月份`
                this.deptId = localStorage.getItem('deptId')
                this.initData()
                this.getPurchasePricePage()
                this.getOpenMealPriceList()
                this.getFoodInformationPage()
                this.getIncomeExpenditureTotal()
                this.getIllegalTotal()
                this.getIllegalPage()
                this.getRecord() //收入费用公示
            },
            // 收入费用公示
            getRecord() {
                this.$get(this.$api.getRecord, {
                    deptId: this.deptId,
                    peroidMonth: this.time
                }).then(res => {
                    console.log(res, '收入费用公示*************');
                    if (res.code === 200) {
                        let {
                            prePeriodEarnings,
                            totalIncome,
                            totalFee,
                            foodIncome,
                            schoolSubsidyIncome,
                            interestIncome,
                            otherIncome,
                            financialSubsidyIncome,
                            foodCostFee,
                            assetDisposalFee,
                            isUse,
                            allPeriodEarnings
                        } = res.data
                        this.monySum = {
                            prePeriodEarnings,
                            isUse,
                            allPeriodEarnings
                        }
                        this.currentSurplusArr = [{
                                title: '本期收入',
                                num: totalIncome
                            },
                            {
                                title: '伙食费收入',
                                num: foodIncome
                            },
                            {
                                title: '财政补助收入',
                                num: financialSubsidyIncome
                            },
                            {
                                title: '学校补助收入',
                                num: schoolSubsidyIncome
                            },
                            {
                                title: '利息收入',
                                num: interestIncome
                            }, {
                                title: '其他收入',
                                num: otherIncome
                            }
                        ]
                        this.currentExpensesArr = [{
                                title: '本期费用',
                                num: totalFee
                            },
                            {
                                title: '伙食成本费用',
                                num: foodCostFee
                            },
                            {
                                title: '资产处置费用',
                                num: assetDisposalFee
                            }
                        ]
                    }
                })
            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {
            this.getShowDivs();
            this.getData()
        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
            this.getDateWeek()
            setInterval(() => {
                this.getData()
            }, 360000);
        },
        beforeCreate() {}, //生命周期 - 创建之前
        beforeMount() {}, //生命周期 - 挂载之前
        beforeUpdate() {}, //生命周期 - 更新之前
        updated() {}, //生命周期 - 更新之后
        beforeDestroy() {}, //生命周期 - 销毁之前
        destroyed() {}, //生命周期 - 销毁完成
        activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>

<style lang="scss" scoped>
    .vertical {
        ::v-deep .custom-title {
            left: inherit !important;
            width: 100% !important;
            top: vh(18) !important;
        }

        ::v-deep .scoll_warp,
        ::v-deep .unified-meal,
        ::v-deep .scorll-ant {
            animation: none !important;
            transform: translate(0, 0) !important;
        }

        ::v-deep .scoll_warp > div {
            transform: translate(0, 0) !important;
            transition: none !important;
        }

        ::v-deep .scoll_warp > div > div:last-child {
            display: none !important;
        }

        ::v-deep .scroll_ist.flex {
            width: 90%;

            .scoll_warp {
                width: 100%;
                white-space: break-spaces;

                ul li .page_list .page_title {
                    flex: 0 0 30%;
                    width: 30% !important;
                }
            }
        }

        .surplus-box {
            box-sizing: border-box;
        }

    }

    .page_index {
        height: 100%;

        .body_part {
            width: 100%;
            @include flex(space-around);
            height: vh(976);
            box-sizing: border-box;

            >div {
                height: 100%;
            }

            .left {
                @include flex(space-between);
                padding-top: vh(6);
            }
        }

        .page_line {
            width: 90%;
            height: vh(1);
            margin: 0 auto;
            background: linear-gradient(to right,
                    #00048f 0%,
                    #00048f 10%,
                    #00558b 20%,
                    #00558b 30%,
                    #00558b 40%,
                    #00558b 50%,
                    #00558b 60%,
                    #00558b 70%,
                    #00558b 80%,
                    #00048f 90%,
                    #00048f 100%);
        }

        .page_padding {
            padding-top: vh(90);
        }
        .page1,
        .page7 {
            padding-left: vh(10);
            padding-right: vh(10);
        }
        .page2 {
            .page2-inner {
                position: relative;
                background: url('../../assets/images/bg_tab1.png') 0 0 no-repeat;
                background-size: 100% 100%;
            }
        }
        .page22 {
            padding-top: vh(20);
        }
        .page10 {
            padding-top: vh(40);
        }
        .page11,
        .page12,
        .page13,
        .page14,
        .page15,
        .page16 {
            background-color: #00048F;
            padding: vh(40) 14px vh(14);
            border-radius: vh(5);
        }

        $paddingLeftRight: vh(20);
        .page3 {
            // margin: 0 vh(10);
            background: url('../../assets/images/bg_tab2.png') 0 0 no-repeat;
            background-size: 100% 100%;
            position: relative;
            padding: 0 0 vh(30);
            min-height: vh(800);

            .sub-title {
                position: absolute;
                top: vh(20);
                right: vh(20);
                font-size: vh(14);
                color: #FBB5FF;
            }

            .unit {
                color: #ffffff;
            }
        }

        .page-common-pad {
            padding: vh(30) 14px vh(14);
        }

        .page_right {
            width: 90%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .page_article {
            padding-top: vh(35);
        }

        .page_line_right {
            width: 80%;
            height: vh(1);
            margin: vh(10) auto auto;
            background: linear-gradient(to right,
                    #0030ca 0%,
                    #1c52ff 10%,
                    #1c52ff 20%,
                    #1c52ff 30%,
                    #1c52ff 40%,
                    #1c52ff 50%,
                    #1c52ff 60%,
                    #1c52ff 70%,
                    #1c52ff 80%,
                    #1c52ff 90%,
                    #0030ca 100%);
        }

        // 2022/12/1  新版收入费用公示
        .revenueExpense {
            padding: vh(50) 0 vh(20);
            display: flex;
            color: #fff;
            font-size: vh(21);
            font-weight: bold;
            margin-left: vh(140);
            margin-left: inherit !important;
            justify-content: center;
        }

        .currentSurplus,
        .currentExpenses,
        .accumulatedSurplus {
            div {
                &:nth-child(1) {

                    &::before {
                        content: '';
                        display: inline-block;
                        width: vh(8);
                        height: vh(16);
                        margin-right: vh(6);
                        background: url('../../assets/images/test_arrow.png') 0 0 no-repeat;
                        background-size: 100% 100%;
                        transform: rotate(180deg);
                    }
                    &::after {
                        content: '';
                        display: inline-block;
                        width: vh(8);
                        height: vh(16);
                        margin-left: vh(6);
                        background: url('../../assets/images/test_arrow.png') 0 0 no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }

        .currentSurplus,
        .currentSurplusActive,
        .currentExpenses,
        .accumulatedSurplus {
            display: flex;
            justify-content: space-between;
            font-size: vh(24);
            padding: vh(20) $paddingLeftRight vh(30);
            color: #FBB6FF;
        }

        .currentSurplusActive {
            font-size: vh(21);
            padding: 0 $paddingLeftRight vh(15) vh(14)+$paddingLeftRight;
            margin-bottom: vh(10);
            border-bottom: 1px solid #9F77F9;

            .box-title {
                color: #ffffff;
            }
        }

        // .currentExpenses {
            // padding: vh(70) vh(40) vh(30) vh(40);
        // }

        // .accumulatedSurplus {
            // padding: vh(30) vh(40) vh(30) vh(40);
        // }
    }

    .warp {
        height: 500px;
        width: 100%;
        margin: 0 auto;
        overflow: hidden;

        .self-service-meal {
            table {
                @include font(24, #ffffff, center);
                width: 100%;
                border-collapse: collapse;

                thead {
                    th {
                        padding: vh(15) 0;
                    }
                }

                tbody {

                    tr {
                        position: relative;

                        td {
                            padding: vh(15) 0;

                            .week {
                                @include font(30, #1DB7FF, center);
                            }

                            .date {
                                color: #FFF;
                            }
                        }

                        .gradient-line {
                            content: '';
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 3px;
                            /* 或您需要的边框高度 */
                            background: linear-gradient(90deg, #00048F, #0066B4, #00048F);
                        }
                    }
                }
            }
        }
    }
</style>
